
































































































import { Watch, Component, Prop, Vue } from 'vue-property-decorator'
import { RealworksCredentials } from '@/api/model/credentials'
import { RealworksCredentialsAPI } from '@/api/backend-client'
import { Branch } from '@/api/model/branch'

@Component
export default class CreateRealworksCredentialsForm extends Vue {
    @Prop({ required: true }) readonly value!: RealworksCredentials
    validating: boolean = false
    showError: boolean = false
    autoConfiguring: boolean = false

    async autoConfig(): Promise<void> {
        try {
            this.autoConfiguring = true
            const results = await RealworksCredentialsAPI.validate(this.value)
            this.value.canRequestFacturen = results.facturen
            this.value.canRequestObjecten = results.objecten
            this.value.canRequestAgenda = results.agenda
            this.value.canRequestTaken = results.taken
            this.value.canRequestRelaties = results.relaties
            this.autoConfiguring = false

        } catch (error) {
            this.autoConfiguring = false
        }
    }

    async validatePermission(permission: string): Promise<boolean> {
        try {
            this.validating = true
            const results = await RealworksCredentialsAPI.validate(this.value)
            const result = results[permission]

            if (result === false) {
                this.showError = true
                setTimeout(() => this.showError = false, 4000)
            }

            this.validating = false
            return results[permission]

        } catch (error) {
            console.error(error)
            this.showError = true
            this.validating = false
            setTimeout(() => this.showError = false, 4000)
            return false
        }
    }

    get yesNoOptions() {
        return [
            { label: this.$t('yes'), value: true },
            { label: this.$t('no'), value: false },
        ]
    }

    @Watch('value.canRequestFacturen')
    async onCanRequestFacturenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('facturen')
        if (canActivate === false) {
            this.value.canRequestFacturen = false
        }
    }

    @Watch('value.canRequestObjecten')
    async onCanRequestObjectenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('objecten')
        if (canActivate === false) {
            this.value.canRequestObjecten = false
        }
    }

    @Watch('value.canRequestAgenda')
    async onCanRequestAgendaChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('agenda')
        if (canActivate === false) {
            this.value.canRequestAgenda = false
        }
    }

    @Watch('value.canRequestTaken')
    async onCanRequestTakenChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('taken')
        if (canActivate === false) {
            this.value.canRequestTaken = false
        }
    }

    @Watch('value.canRequestRelaties')
    async onCanRequestRelatiesChange(value: boolean) {
        if (value === false) {
            return
        }

        const canActivate = await this.validatePermission('relaties')
        if (canActivate === false) {
            this.value.canRequestRelaties = false
        }
    }

    get availableBranches(): Branch[] {
        return this.$currentCompany.getAvailableBranches()
    }

    get isAgendaEnabled(): boolean {
        return this.value?.canRequestAgenda === true
    }

    get isObjectEnabled(): boolean {
        return this.value?.canRequestObjecten === true
    }
}
